import { IconNameType } from '../../components/base/icon/Icon.data'
import { ROUTES } from '../../routes/path'

export type NavItem = {
  route?: string
  icon: IconNameType
  label: string
  hidden?: boolean
}

const NavItems: Array<NavItem[]> = [
  [
    {
      icon: 'chart',
      label: 'Dashboards',
      route: ROUTES.home.dashboards.base
    },
  ],
]

export default NavItems
